import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'auth',
  initialState: {
    // KEEP — read by App.js (fetchUser) and main/main.js (route guard)
    userData: null,

    // Legacy e-clinicx — sign-up / sign-in / OTP state
    // errorMsg: '',
    // signUpLoading: false,
    // signInLoading: false,
    // isLogin: false,
    // otp: '',
  },
  reducers: {
    // KEEP — App.js dispatches fetchUser() on app start
    fetchUser: (state) => {
      let data = localStorage.getItem('userData')
      let parsedData = JSON.parse(data)
      state.userData = parsedData
    },
    // KEEP — used for logging the public-site user out
    logout: (state) => {
      state.userData = null
      localStorage.removeItem('userData')
    },

    // Legacy e-clinicx — sign-up / sign-in / OTP flows are disabled.
    // Uncomment together with main/redux/auth/saga.js and the `authApi`
    // block in main/services/index.js.
    //
    // userSignUp: (state) => {
    //   state.signUpLoading = true
    //   state.errorMsg = ''
    //   state.isLogin = false
    // },
    // userSignUpSuccess: (state, { payload: { payload } }) => {
    //   localStorage.setItem('userData', JSON.stringify(payload.data))
    //   state.signUpLoading = false
    //   state.userData = payload.data
    //   state.isLogin = true
    // },
    // userSignUpFailed: (state, { payload }) => {
    //   state.userData = null
    //   state.signUpLoading = false
    //   state.errorMsg = payload.message
    //   state.isLogin = false
    // },

    // userSignIn: (state) => {
    //   state.signInLoading = true
    //   state.errorMsg = ''
    //   state.isLogin = false
    // },
    // userSignInSuccess: (state, { payload: { payload } }) => {
    //   localStorage.setItem('userData', JSON.stringify(payload.data))
    //   state.signInLoading = false
    //   state.userData = payload.data
    //   state.isLogin = true
    // },
    // userSignInFailed: (state, { payload }) => {
    //   state.userData = null
    //   state.signInLoading = false
    //   state.errorMsg = payload.message
    //   state.isLogin = false
    // },

    // userVerification: (state) => {
    //   state.otp = ''
    // },
    // userVerificationSuccess: (state, { payload: { payload } }) => {
    //   state.otp = payload.data.otp
    // },
    // userVerificationFailed: (state, { payload }) => {
    //   state.otp = ''
    // },
  },
})

export const {
  fetchUser,
  logout,
  // userSignUp,
  // userSignUpFailed,
  // userSignUpSuccess,
  // userVerification,
  // userVerificationFailed,
  // userVerificationSuccess,
  // userSignIn,
  // userSignInSuccess,
  // userSignInFailed,
} = slice.actions

export default slice.reducer
